import { HTMLProps, ReactNode } from 'react';

interface Props {
  forId: string;
  children: ReactNode;
}

export function Label({
  forId,
  children,
  ...rest
}: Props & HTMLProps<HTMLLabelElement>) {
  return (
    <label
      htmlFor={forId}
      {...rest}
      className={`${rest.className} block font-title-4_web-desktop-min text-on-screen-surface`}
    >
      {children}
    </label>
  );
}
